import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { LoadingDialog } from "../../../../_metronic/_partials/controls";


export function UnpaidAgentsLoadingDialog() {
  const { isLoading } = useSelector(
    (state) => ({ isLoading: state.unpaidAgents.listLoading }),
    shallowEqual
  );

  return <LoadingDialog isLoading={isLoading} />;
}
